import { EnvironmentProviders, Provider, inject, provideAppInitializer } from "@angular/core";
import { AuthService } from "@services/auth.service";
import { StorageService } from "@services/storage.service";
import { SITES_BUILDER_AUTH_SESSION } from "./auth-session";

function initializeAuthFactory(authService: AuthService) {
  return () => authService.setupSilentRefresh();
}

export const AuthProvider: (Provider | EnvironmentProviders )[] = [
  StorageService,
  AuthService,
  {
    provide: SITES_BUILDER_AUTH_SESSION,
    useExisting: AuthService,
  },
  provideAppInitializer(() => {
        const initializerFn = (initializeAuthFactory)(inject(AuthService));
        return initializerFn();
      })
];
